import { FileStoreService } from 'src/app/shared/_services/file-store.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { PrimaNotaStoreService } from './../_services/primaNota-store.service';
import { ApiRestService } from './../_services/api-rest.service';
import { ApiRestService as AziendeApiRestService } from '../../Admin/_service/api-rest.service';
import { Component, OnInit } from '@angular/core';
import { Spesa } from '../Models/Spesa';
import { ActivatedRoute, Router } from '@angular/router';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Categorie } from 'src/app/Progetti/Models/Categorie';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {Azienda} from "../../Admin/models/Azienda";
import {AziendeStoreService} from "../../Admin/_service/aziende-store.service";
import {Fattura} from "../Models/fattura";

@Component({
  selector: 'app-edit-fattura',
  templateUrl: './edit-fattura.component.html'
})
export class EditFatturaComponent implements OnInit {
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
  };
  oggi = new Date();
  subscriptions: Subscription = new Subscription();
  Selected: Fattura = new Fattura();
  aziende: Azienda[] = [];
  aziendeSelezionate: Azienda[] = [];
  constructor(
    private apiRest: ApiRestService,
    private aziendeApiRest: AziendeApiRestService,
    private filestore: FileStoreService,
    private primanotaStore: PrimaNotaStoreService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private aziendeStore: AziendeStoreService,
    ) { }
  ngOnInit() {
    this.aziendeStore.getListaAziende({page:0, size:10});
    this.subscriptions.add(this.aziendeStore.$listaAziende.subscribe(data => {
      this.aziende = [];
      if (data)
        this.aziende = data.data
    }));
    this.subscriptions.add(this.primanotaStore.$fattura.subscribe(data => {
      if (!data) {
      } else  {
        this.Selected = data;
        this.filestore.SetListaFile(data.files);
        this.filestore.SelectSection('fatture');
        this.Selected.data_emissione = this.datePipe.transform(data.data_emissione, 'yyyy-MM-dd');
        this.Selected.data_pagamento_e = this.datePipe.transform(data.data_pagamento_e, 'yyyy-MM-dd');
        this.Selected.data_pagamento_p = this.datePipe.transform(data.data_pagamento_p, 'yyyy-MM-dd');
        if(data.clienteObject)
          this.aziendeSelezionate = [data.clienteObject];
      }
    }));
  }
  closeBtnClick() {
    this.primanotaStore.updateEditable(false);
    this.primanotaStore.updateAddable(false);
    this.router.navigate([this.route.snapshot.queryParams['primanota/fatture'] ||'primanota/fatture',]);
  }
  refreshinfo(){
    this.primanotaStore.updateFatturaSelezionata(this.Selected);
  }
  saveClick(){
    if (this.aziendeSelezionate && this.aziendeSelezionate.length>0 && this.aziendeSelezionate[0])
      this.Selected.cliente = this.aziendeSelezionate[0].id;
    if (this.Selected.id && !isNaN(this.Selected.id)) {
      this.apiRest.updateFattura(this.Selected).subscribe(() => this.closeBtnClick(), (error)=>this.refreshinfo() );
    } else {
      this.apiRest.addFattura(this.Selected).subscribe(() => this.closeBtnClick(), (error)=>this.refreshinfo() );
    }
  }
  filtroCategoria(item: string) {
    if (item.length >= 3) {
      this.primanotaStore.getCategorie(new RicercaPaginazione(item, undefined, undefined));
    }
  }
  FornitoreChanged(){
    if (this.aziendeSelezionate && this.aziendeSelezionate.length>0 && this.aziendeSelezionate[0])
      this.aziendeApiRest.getInfoAziende(this.aziendeSelezionate[0]).subscribe(data=>{
        this.Selected.nominativo = data.nominativo;
        this.Selected.indirizzo = data.indirizzo;
        this.Selected.cap = data.cap;
        this.Selected.citta = data.citta;
        this.Selected.provincia = data.provincia;
        this.Selected.nazione = data.nazione;
        this.Selected.piva = data.piva;
        this.Selected.cf = data.cf;
      })

  }
}
